// Pure decision logic for the push-to-talk hotkey, kept jsdom-free so it can
// be unit-tested without a DOM (same pattern as composerFocusModel.ts).
//
// The trigger is **hold Option/Alt** (per user request). `event.key === "Alt"`
// is layout-independent and matches both the left/right Alt keys and macOS
// Option. Alt isn't a printable key, so holding it never inserts characters in
// the composer; the live recorder also stops on window-blur so an Alt+Tab
// can't leave recording wedged on (keyup wouldn't fire after focus leaves).

export interface PttKeyDown {
  // `event.key` — "Alt" for both Alt keys and the macOS Option key.
  key: string;
  // Auto-repeat keydown while the key is held — must NOT re-trigger start.
  repeat: boolean;
}

export interface PttContext {
  // Already recording — a second start is a no-op.
  recording: boolean;
  // A modal overlay is open (⌘K palette / `?` cheat sheet) or the recorder
  // is otherwise disabled — don't grab the mic.
  blocked: boolean;
}

/** Whether this keydown should START push-to-talk recording. */
export function shouldStartPushToTalk(e: PttKeyDown, ctx: PttContext): boolean {
  if (ctx.blocked) return false;
  if (ctx.recording) return false;
  if (e.repeat) return false;
  return e.key === "Alt";
}

export interface PttKeyUp {
  key: string;
}

/** Whether this keyup should STOP an in-progress push-to-talk recording. */
export function shouldStopPushToTalk(e: PttKeyUp, recording: boolean): boolean {
  if (!recording) return false;
  return e.key === "Alt";
}
